export const jobEducationLevelsCz = {
  jobEducationLevels: {
    'no_education_required': 'Bez požadavků',
    'primary_education': 'Základní vzdělání',
    'secondary_education': 'Střední vzdělání',
    'complete_secondary_education': 'Úplné střední vzdělání (maturita)',
    'bachelors_degree': 'Vysokoškolské vzdělání prvního stupně (Bc.)',
    'masters_degree': 'Vysokoškolské vzdělání druhého stupně (Mgr./Ing.)',
    'doctoral_degree': 'Vysokoškolské vzdělání třetího stupně (PhD.)'
  }
};
